export default __webpack_public_path__ + "static/media/03.6d5726d5.png";